const app = require('./app.js')
const loadingBar = require('./ui.loadingBar.js')
const loadingCircle = require('./ui.loadingCircle.js')
const splashScreen = require('./ui.splashScreen.js')
const devices = require('./ui.devices.js')
const bookmarks = require('./ui.bookmarks.js')
const settings = require('./ui.settings.js')
const pricings = require('./ui.pricings.js')
this.data
class ui {
    views = {}
    pricings
    constructor() {
        app.on('dataUpdate', (data) => {
            for (let view in this.views) {
                if (this.views[view] && this.views[view].dataType && this.views[view].dataType == data.type && this.views[view].update) {
                    setTimeout(() => {
                        this.views[view].update(this.views, data)
                    }, 1)
                }
            }
        })
        app.on('stream', (data) => {
            if (this.views['player'] && this.views['player'].id == data.cast_id) {
                this.views['player'].addFrames(data.frames)
                this.views['player'].isLive(data.isLive)
            }
        })
        app.on('user', (data) => {
            if (data.type === 'info') {
                this.userData = data
            }
        })
        app.on('dataUpdate', (data) => {
            if (data.type === 'device') {
                this.data = data
            }
        })
        this.pricings = new pricings()
    }

    documentReady() {
        console.log('Document ready')
        loadingBar.init()
        loadingCircle.init()
        loadingBar.show()
        this.views['settings'] = new settings()

        document.getElementById('menuBookmarks').addEventListener('click', () => {
            if (!this.views.bookmarks) this.views['bookmarks'] = new bookmarks()

            this.views.bookmarks.show()
        })
        document.getElementById('menuSettings').addEventListener('click', () => {
            if (!this.views.settings) this.views['settings'] = new settings()

            this.views.settings.show(this.data, this.userData)
        })

        if (!app.user) {
            let interval = setInterval(() => {
                console.log('waiting for user')
                if (app.user) {
                    this.views['devices'] = new devices()
                    splashScreen.hide()
                    loadingBar.hide()
                    clearInterval(interval)
                }
            }, 100)
        }

        //this.device.show();
    }
}

module.exports = new ui()
